module.exports = __webpack_public_path__ + "img/aDonkiKong_193x205.bc1b17a1.png";